module.exports = __webpack_public_path__ + "static/Lazienka3_V03-c973284a65d8f9425c9cf9b3781d3c46.jpg";